// extracted by mini-css-extract-plugin
export default {"wrapper":"CommonButton_wrapper__pjeav","disabledButton":"CommonButton_disabledButton__JYl6I"};